// extracted by mini-css-extract-plugin
module.exports = {"data":"styles_data__1I_A8","data-type":"styles_data-type__1THEM","value":"styles_value__2IrLu"};